<script type="text/javascript">

    import { http } from '../../http';

    export default {

        data: function(){

            return {

            }
        },
        mounted: function() {
            $('#dpa-consent-modal').modal({
                backdrop: 'static',
                keyboard: false
            });

            $('#dpa-consent-modal').modal('show');
        },
        methods: {

            postpone_consent(){
                http.post('/app/dpa/postpone').then(() => {
                    $('#dpa-consent-modal').modal('hide');
                }).catch(() => {});
            },

            consent(){

                http.post('/app/terms');
                http.post('/app/dpa').then(() => {
                    $('#dpa-consent-modal').modal('hide');
                    toastr.success(trans('settings.terms_and_dpa_confirmation'));
                }).catch(() => {});
            }

        },
        computed: {

            menu_item_link_markup(){
                return '<a href="/app/settings/profile">"'+trans('global.settings')+'"&rarr;"'+trans('settings.profile')+'"</a>';
            },

            mail_markup(){
                return '<a href="mailto:'+trans('global.system_email')+'">'+trans('global.system_email')+'</a>';
            },

            consent_link_markup(){
                return "<a href='/app/dpa' target='_blank'>"+trans("settings.dpa")+" <i class='fa-solid  fa-arrow-down-to-line'></i></a>";
            },

            terms_consent_link_markup(){
                return "<a href='/app/terms' target='_blank'>" + trans('settings.terms_and_conditions') + "<i class='fa-solid  fa-arrow-down-to-line'></i></a>";
            },

            dpa_and_terms_deadline(){
                return moment().locale(moment_locale).format('dddd D MMMM YYYY')
            }

        },
    };


</script>

<template id="dpa-consent">
    <div class="modal-dialog">

        <div class="modal-content">

            <div class="modal-body p-0">
                <h1 class="text-center m-b-0">{{ trans('settings.terms_and_dpa_consent_title') }}</h1>
                <p class="text-muted m-b-20 m-t-0 text-center">{{ trans('settings.terms_dpa_consent_sub_title') }}</p>

                <div class="text-center">

                    <div class="m-b-20">
                        <i class="fa-duotone fa-shield-check" style="font-size: 70px;"></i>
                    </div>

                    <p v-sanitize-html="trans('settings.terms_and_dpa_consent_1', { 'link' : consent_link_markup, 'terms_link' : terms_consent_link_markup})"></p>

                    <p v-sanitize-html="trans('settings.terms_and_dpa_consent_2', {'dead_line': dpa_and_terms_deadline})"></p>

                    <p v-sanitize-html="trans('settings.terms_and_dpa_consent_3', { 'link' : menu_item_link_markup, 'mail' : mail_markup })"></p>

                    <a class="m-t-10 m-b-10 btn-custom btn btn-lg text-center" @click.prevent="consent"><i class="zmdi zmdi-check m-r-10"></i>{{ trans('settings.terms_and_dpa_consent_approve') }}</a>

                    <small class="truncate m-t-10"><a href="" class="text-muted" @click.prevent="postpone_consent" ><u>{{ trans('settings.terms_and_dpa_consent_postpone_1') }}</u> {{ trans('settings.terms_and_dpa_consent_postpone_2') }}</a></small>

                </div>

            </div>
        </div>
    </div>
</template>
